export default {
    CSMentorTeam: [{
        name: "Daniel",
        title: "Stanford CS博士",
        image: require("@/assets/img/team/cs_03.jpg"),
        content: "Stanford CS博士，研究集中在AI领域，具体包括生成模型、动力学模拟和图神经网络等等。曾同时获得CMU, Berkeley, Princeton, Caltech, Yale, Uiuc等计算机博士全奖offers。",
        evaluate: ["mentor认真负责，分享 的内容和回答的问题学生都很认可。回复及时并且好约上。", "回复消息也及时，很积极，比较专业。"]
    }, {
        name: "William",
        title: "MIT EECS博士",
        image: require("@/assets/img/team/cs_04.jpeg"),
        content: "MIT EECS博士，研究领域主要集中在计算机视觉，多模态学习，自然语言处理，人工智能。曾同时获得Stanford, UIUC, Oxford等计算机博士全奖offers。",
        evaluate: []
    }, {
        name: "Paul",
        title: "CMU CS博士",
        image: require("@/assets/img/team/cs_05.jpeg"),
        content: "CMU CS博士，研究领域主要集中在多模态语言模型，以及图像和文本生成模型的研究。",
        evaluate: ["基本为线上meeting时间及微信回复学生信息时间。mentor人很nice，群里信息回复比较及时。", "回复及时，约meeting能很快约上。", "该mentor能针对学生的基本情况给出合理的建议，比较耐心，专业。"]
    }, {
        name: "David",
        title: "CMU CS和Robotics博士",
        image: require("@/assets/img/team/cs_06.jpeg"),
        content: "CMU CS和Robotics博士，主要研究领域为计算机视觉、机器人，以及AR/VR等。",
        evaluate: ["学生抠的文书细节非常多，期间加上暑研老板的一些意见，所以多次meeting确定最终内容，mentor非常及时认真的处理学生的问题，非常nice的一位mentor！", "指导的特别棒，群里面回复也很积极~", "回复比较及时，也很认真负责。"]
    }, {
        name: "Emma",
        title: "UC Berkeley EECS博士",
        image: require("@/assets/img/team/cs_01.jpg"),
        content: "UC Berkeley EECS博士，研究领域主要集中在大规模异构系统上加速/优化计算等方面。",
        evaluate: ["回复挺及时的，回复学员关于科研等专业问题很详细细致，态度也很友好。", "mentor指导还是可以的，比较专业，也能指出修改建议，回复及时。", "工作质量没有问题，解答问题很详细。"]
    }, {
        name: "Michael",
        title: "Princeton ECS博士",
        image: require("@/assets/img/team/cs_07.jpeg"),
        content: "Princeton ECS博士，主要研究领域在自然语言处理及相关问题。曾同时获得了UIUC, GaTech等计算机全奖offers。",
        evaluate: ["该mentor非常专业，细心，耐心，meeting能很好的给学生进行讲解。", "对于学生的的问题能给到很好的解答，比较认真。", "工作认真，质量较好。"]
    }, {
        name: "Robert",
        title: "UC Berkeley博士",
        image: require("@/assets/img/team/cs_08.jpeg"),
        content: "UC Berkeley博士，主要研究领域在计算机视觉，机器学习等，特别是AI在医疗领域方面的应用研究。",
        evaluate: ["mentor负责耐心，提出的建议学员也很认可。meeting完后，我有单独和学生沟通问体验情况，学生反馈体验感不错。给力点赞！", "特别好，meeting非常认真，给了学生很详细的指导规划，效率也很高。", "该mentor非常好。跟学生讲解会先做功课，会给学生讲解相关专业的背景，分析学生的方向，给学生非常中肯的建议。学生非常满意！"]
    }, {
        name: "Isabella",
        title: "Stanford EE博士",
        image: require("@/assets/img/team/cs_02.jpg"),
        content: "Stanford EE博士，主要研究领域在计算神经科学，以及机器人，深度学习，控制和优化等。",
        evaluate: ["非常好！回复很及时，修改文书也很认真，态度非常谦和，跟学员沟通时很有耐心，给好评！", "回复很及时的，态度很友好负责，对于申请文书的指导非常专业详细，好评！", "没问题，mentor很专业。"]
    }, {
        name: "Evelyn",
        title: "UCSD CSE博士",
        image: require("@/assets/img/team/cs_09.jpg"),
        content: "UCSD CSE博士，主要研究领域在自然语言处理，人工智能音乐等。",
        evaluate: []
    }, {
        name: "Ava",
        title: "MIT博士",
        image: require("@/assets/img/team/cs_10.jpeg"),
        content: "MIT博士，Stanford CS硕士毕业，主要研究领域为Robot learning and human robot interactions等。",
        evaluate: ["mentor工作无误，指导也不错，性格也挺好的，能有效沟通，今年指导的同学拿到了Stanford CS offer。", "mentor比较认真负责，会主动回答学员在群里提问的问题。", "mentor给学生修改的cv和邮件都很及时且质量很高，帮助学生成功找到暑研。"]
    }, {
        name: "Edward",
        title: "Stanford CS博士",
        image: require("@/assets/img/team/cs_11.jpeg"),
        content: "Stanford CS博士，主要研究领域为计算机视觉，机器学习等。曾同时收获CMU Machine Learning PhD等等offers。",
        evaluate: ["mentor可以很好地回答专业上的问题，在修改文书上也能提出很好的建议。", "他挺不错的，约meeting回应一般很快，也从来没有说过我很忙，不能约的情况。个人能力强，给学生说专业的问题清晰易懂，学生也挺崇拜他的。", "mentor很效率 整体都不错。"]
    }, {
        name: "Luna",
        title: "CMU CS博士",
        image: require("@/assets/img/team/cs_12.jpeg"),
        content: "CMU CS博士，主要研究领域包括System: Storage Systems, Cloud Computing and other system issues等。",
        evaluate: ["mentor耐心负责,专业细心,对学生帮助很多,是很好的mentor,谢谢老师安排这么好的mentor。", "文书和选校的建议上会比较有针对性，会比较受学生的喜欢，让学生有亲学姐的体验，点赞！", "mentor很懂学生的方向，跟学生聊的也比较专业，能帮助学生修改文书。暂时学生非常满意。"]
    }, {
        name: "Richard",
        title: "UC Berkeley EECS博士",
        image: require("@/assets/img/team/cs_13.jpeg"),
        content: "UC Berkeley EECS博士，主要研究领域在AI for Science / Computational Biology。曾同时收获CMU, Princeton, UIUC, Duke, Gatech等博士offers。",
        evaluate: []
    }, {
        name: "Steven",
        title: "Oxford计算机博士",
        image: require("@/assets/img/team/cs_14.jpeg"),
        content: "Oxford计算机博士，主要研究领域集中在计算机视觉，信号处理，机器学习等领域。",
        evaluate: ["mentor指导材料比较上心，给的建议很中肯，学生信赖，目前合作顺畅。", "Mentor对于学生的指导很用心，指导也比较专业，经常会督促学生进度。", "mentor回复消息及时，指导简历和ps ，面试回答都可以。"]
    }, {
        name: "Charlotte",
        title: "Stanford CS硕士",
        image: require("@/assets/img/team/cs_15.jpeg"),
        content: "Stanford CS硕士，清华姚班本科毕业，主要研究领域为数据库系统和数据科学方向等。",
        evaluate: ["文书指导会帮学生分析逻辑主线，也愿意配合学生的deadline来进行工作加急。", "简历和ps 指导可以，文书修改也比较及时。"]
    }, {
        name: "Camila",
        title: "Stanford CS硕士",
        image: require("@/assets/img/team/cs_16.jpeg"),
        content: "Stanford CS硕士，曾同时收获Columbia MSCS/ Yale MSCS/ UCLA Meng DS/ CMU MSIN/ Cornell Meng CS/ UofToronto MScAC CS/ Oxford MSc in ACS等。",
        evaluate: []
    }, {
        name: "Eleanor",
        title: "Stanford CS硕士",
        image: require("@/assets/img/team/cs_17.jpeg"),
        content: "非相关本科专业，转专业申请CS，录取Stanford CS硕士，同时收获Gatech, USC计算机硕士等offers。",
        evaluate: ["mentor很专业，目前指导暑研和选课等都不错，很适合转专业申请CS的学生，态度也很积极，会主动约meeting来解决学生的问题。", "mentor详细的回复了学生的问题，给学生做了清晰的规划。", "mentor工作负责，回复挺及时的，给学生改文书也可以的。"]
    }, {
        name: "Violet",
        title: "Stanford CS硕士",
        image: require("@/assets/img/team/cs_18.jpeg"),
        content: "加拿大本，Stanford CS硕士，同时收获哈佛大学 CSE，卡耐基梅隆大学 MSR/MSML，剑桥大学 MLMI，苏黎世联邦理工 MSCS，佐治亚理工 CS PhD，马里兰大学 CS PhD，多伦多大学 ECE PhD等offers。",
        evaluate: []
    }, {
        name: "Brian",
        title: "UPenn CS博士",
        image: require("@/assets/img/team/cs_19.jpeg"),
        content: "美国常青藤本科毕业，UPenn CS博士，主要研究领域为机器人，机器视觉，和人工智能等。",
        evaluate: []
    }, {
        name: "Kenneth",
        title: "UW计算机博士",
        image: require("@/assets/img/team/cs_20.jpeg"),
        content: "UW计算机博士，主要研究领域为理论计算机。",
        evaluate: ["mentor很好，针对学生的方向，进行了很细致的讲解。学生很满意。", "mentor整体都很好～"]
    }, {
        name: "Ronald",
        title: "Cambridge计算机博士",
        image: require("@/assets/img/team/cs_21.jpeg"),
        content: "Cambridge计算机博士，主要研究领域为VR/AR，元宇宙，计算机媒体与艺术方向等。",
        evaluate: []
    }, {
        name: "Aurora",
        title: "CMU MITS",
        image: require("@/assets/img/team/cs_22.jpg"),
        content: "CMU MITS项目毕业，现任美国Amazon公司软件工程师，丰富的指导世毕盟学员成功申请美国top CS硕士的工作经验。",
        evaluate: ["mentor指导可以，比较认真详细。", "mentor工作认真负责，深受学生好评。又专业又耐心，非常棒的一个mentor。"]
    }, {
        name: "Penelope",
        title: "USC IMGD",
        image: require("@/assets/img/team/cs_23.jpeg"),
        content: "美国top游戏设计项目USC IMGD毕业，现就职于世界知名游戏设计公司。",
        evaluate: ["mentor的工作很到位，meeting也能讲。"]
    }, {
        name: "Scarlett",
        title: "Stanford EE硕士",
        image: require("@/assets/img/team/cs_24.jpeg"),
        content: "Stanford EE硕士毕业，曾同时收获CMU MCDS，ETH MSCS，Columbia MSCS，UCB Meng等offers，现就职于美国知名互联网大厂。",
        evaluate: ["Mentor 沟通能力强，懂的比较多，学生挺满意的，不过就是上次会议迟到了两分钟，不过学生没有介意～目前合作下来还挺好的～", "mentor指导认真专业，能够针对学生提出的问题给出具体的指导建议，meeting准时积极。"]
    }],
    MFEMentor: [{
        name: "Betty",
        title: "Princeton MFin",
        image: require("@/assets/img/team/mfe_01.jpeg"),
        content: "Princeton MFin毕业，top国际投行实习和工作经验，曾同时收获Princeton MFin, MIT MFin, Columbia MFE, Cambridge Real Estate Finance, Oxford MFE等offers，可同时指导金融工程和纯金融的学生。丰富的指导世毕盟学员的工作经验。",
        evaluate: ["mentor回复效率非常高，非常有服务意识，给的意见非常中肯。", "mentor工作比较认真，文书修改的比较细致，能根据学生背景提出比较专业的背景提升建议，跟学生的沟通截止目前都比较顺畅，她也是个很好合作的mentor！", "mentor指导认真负责，对学生的问题能够给出针对性的指导建议，指导效率高，meeting准时。"]
    }, {
        name: "Benjamin",
        title: "Princeton MFin",
        image: require("@/assets/img/team/mfe_02.jpeg"),
        content: "Princeton MFin毕业，top国际投行实习和工作经验，非清北陆本上普林金融，top国际投行实习和工作经验，曾同时收获Columbia MFE，CMU MSCF，MIT MFin等offers。丰富的指导世毕盟学员的工作经验。",
        evaluate: ["mentor对待学生非常负责，总是积极回复学生，给学生一个非常良好的印象，即使是在阳了以后，依然能够给出学生非常专业的指导，是极好的mentor。", "mentor工作比较认真，群里信息回复很及时，跟学生的沟通比较顺畅，针对学生的问题都能给出比较专业的回答。是个很好合作的mentor！", "我的mentor态度积极，热情，专业，赞赞赞。"]
    }, {
        name: "William",
        title: "Princeton MFin",
        image: require("@/assets/img/team/mfe_03.jpeg"),
        content: "Princeton MFin，非清北陆本上普林金融，丰富的量化金融相关背景；曾同时收获Harvard Master’s in Data Science，CMU MSCF, NYU MSMF等offers。",
        evaluate: ["这mentor太牛了，无论选课，职业发展方向的细分，还是未来就业求职，无所不能啊，开会的时候全程高能，真牛。", "mentor人很nice, 第一次meeting跟学生沟通的比较顺畅，后面又约了一次meeting讨论修改了学生目前的简历，截止目前的指导工作都比较顺利。", "mentor最近针对外资summer提供了很多建议，非常负责。"]
    }, {
        name: "Bonnie",
        title: "Princeton MFin",
        image: require("@/assets/img/team/mfe_04.jpeg"),
        content: "Princeton MFin，应用数学本科，外资投行实习和工作经验。丰富的指导世毕盟学员的工作经验。",
        evaluate: ["mentor工作负责，回复及时，指导建议很实用，学员很满意。", "mentor高效，解决问题，专业度也很好。可以给学生提供较多personal insight。"]
    }, {
        name: "Caroline",
        title: "Princeton MFin",
        image: require("@/assets/img/team/mfe_05.jpeg"),
        content: "Princeton MFin毕业，清北本上普林金融，国际投行实习和工作经历，曾同时收获CMU MSCF, Baruch MFE，Cornell MFE等offers。丰富的指导世毕盟学员的工作经验。",
        evaluate: ["mentor很负责对学生的ps内容修改很到位很细致，且每次都很准时。", "mentor回复都很及时，指导也详细，日后如果有其他新学员，强烈推荐她。", "人很nice，性格很好，和学生沟通顺畅，且信息处理速度快。"]
    }, {
        name: "Sophia",
        title: "MIT Sloan MBAn",
        image: require("@/assets/img/team/mfe_06.jpeg"),
        content: "MIT Sloan MBAn，多家科技公司及创业公司的实习经验，丰富的指导世毕盟学员的工作经验。",
        evaluate: ["mentor指导也很细致，回复很积极，能很快约上meeting。", "mentor反馈较及时，效果不错。", "mentor能够针对具体问题给出针对性的专业建议，文书修改高效认真，meeting准时。"]
    }, {
        name: "Florence",
        title: "MIT Sloan MBAn",
        image: require("@/assets/img/team/mfe_07.jpeg"),
        content: "MIT Sloan MBAn，多家科技公司的实习经验，曾同时收获NYU MSDS, UChicago MScA (MSADS)等offers；丰富的指导世毕盟学员的工作经验。",
        evaluate: ["mentor人很nice，工作比较认真，能够结合学生的实际情况给出背景提升建议，截止目前她跟学生的沟通都比较顺畅。", "该mentor专业度高，修改简历的时候表现得细心，回复及时。", "mentor专业，背景好，能力优秀，会鼓励学生向mentor学习，回复简约直接，很给力。"]
    }, {
        name: "Samue",
        title: "北美应用数学博士",
        image: require("@/assets/img/team/mfe_08.jpeg"),
        content: "拒绝Harvard Master’s in Data Science，中外合作办学本科，北美应用数学博士。丰富的指导世毕盟学员的工作经验。",
        evaluate: []
    }, {
        name: "Amelia",
        title: "Harvard Master’s in DS",
        image: require("@/assets/img/team/mfe_09.jpeg"),
        content: "Harvard Master’s in Data Science，美国应用数学和统计学本科。丰富的指导世毕盟学员的工作经验。",
        evaluate: ["回复效率高，精简，认真负责，情商也很高，对学生建议清楚。", "对简历和选校的指导都挺好的，群里面的消息回复及时~", "指导学生比较有亲和力，也输出general的建议，响应也很快。"]
    }, {
        name: "Charlotte",
        title: "Harvard Master’s in DS",
        image: require("@/assets/img/team/mfe_10.jpeg"),
        content: "Harvard Master’s in Data Science，陆本转专业申请到哈佛数据科学。丰富的指导世毕盟学员的工作经验。",
        evaluate: ["效率挺高的，三言两语可以跟学生讲清楚修改思路，沟通顺畅，回复也快，可以推荐。", "mentor非常靠谱，给的文书指导建议很好，很专业，在群里也能回复信息，而且最好的一点是效率很高！", "CV和PS批注了很多意见，修改的很认真。"]
    }, {
        name: "Freya",
        title: "MIT Sloan MFin",
        image: require("@/assets/img/team/mfe_11.jpg"),
        content: "MIT Sloan MFin，美国经济学本科，国际金融机构实习和工作经验；曾同时收获Yale SOM AM, Columbia Econ, Cambridge FE等offers。",
        evaluate: ["mentor约meeting很及时，改文书提前先看过文书，给的建议很到位，也很耐心。", "目前的几次合作来看，meeting指导挺及时，效率也挺高的~", "非常专业，修改文书到位，回复及时，认真负责，效率高！"]
    }, {
        name: "Olivia",
        title: "MIT Sloan MFin",
        image: require("@/assets/img/team/mfe_12.jpg"),
        content: "MIT Sloan MFin，经济学陆本，丰富的实习经历，曾同时收获UChicago MPP, UCLA MQE等offers。丰富的指导世毕盟学员的工作经验。",
        evaluate: ["目前因为学生非常着急交申请（还远没到ddl）文书的修改算是根据学生觉得OK的细致程度改的；mentor这边看文书还是比较细的，工作质量没问题，工作效率非常OK！", "mentor回复及时，沟通态度很好，对自己申请过的专业纯金融方向非常了解。", "mentor回复及时，沟通能力没问题，对学生也比较有耐心。"]
    }, {
        name: "Isabella",
        title: "MIT Sloan MFin",
        image: require("@/assets/img/team/mfe_13.jpg"),
        content: "MIT Sloan MFin，美国经济学本科，辅修数学和心理；丰富的投行、风投和私募的实习经验。丰富的指导世毕盟学员的工作经验。",
        evaluate: ["mentor约meeting非常及时，还会在她方便的时间催学生赶好文书早帮学生修改，文书指导以及选校指导都非常有针对性，效率也很高！", "mentor效率很高，回复快。指导也不错。", "mentor指导学生挺及时也挺专业，上次meeting学生文书是突然临时发的导致未提前准备，我跟mentor都批评过学生了。"]
    }, {
        name: "Phoebe",
        title: "MIT Sloan MFin",
        image: require("@/assets/img/team/mfe_14.jpg"),
        content: "MIT Sloan MFin，美高美本（统计学），丰富的美国本土金融行业实习和工作经历；丰富的指导世毕盟学员的工作经验。",
        evaluate: ["mentor尽心尽责，即使是在圣诞假期也能够约到meeting一起讨论文书，且文书建议非常细致专业，是专业负责的好mentor。", "mentor工作认真负责，量化金融知识十分专业，学生十分满意。", "学生预约meeting修改即将ddl的文书，mentor回复及时并高效率的修改申请文书，帮学生申请到了这个项目。"]
    }, {
        name: "Christopher",
        title: "MIT Sloan MFin",
        image: require("@/assets/img/team/mfe_15.jpg"),
        content: "MIT Sloan MFin，香港大学本科，丰富的金融机构实习和工作经验；曾同时收获Yale SOM AM, Cambridge FE等offers。丰富的指导世毕盟学员的工作经验。",
        evaluate: ["mentor指导专业有效，能够针对学生的现状和提出的问题给出具体的建议和思路，meeting准时积极。", "mentor改文书蛮认真的，也会积极帮助同学理思路。比较细心负责。", "mentor认真负责，会和学员详细沟通，及时解答问题。"]
    }, {
        name: "Sienna",
        title: "MIT Sloan MFin",
        image: require("@/assets/img/team/mfe_16.jpg"),
        content: "MIT Sloan MFin毕业，陆本，国际top投行实习和工作经历；曾同时收获Columbia Business School MSFE, CMU MSCF, NYU MSMF等offers。丰富的指导世毕盟学员的工作经验。",
        evaluate: ["mentor人很nice, 工作比较认真，群里信息回复很及时，学生已经在她的指导下拿到Baruch MFE的录取，她也是个很好合作的mentor。", "mentor专业度高，指导简历和文书修改具有针对性，能说出有建设性的建议，工作态度，积极回复及时。", "mentor人很nice, 文书修改建议提得比较中肯，群里回复信息也比较及时，目前跟学生的沟通还比较顺畅，是个很好合作的mentor。"]
    }, {
        name: "Anthony",
        title: "CMU MSCF",
        image: require("@/assets/img/team/mfe_17.jpeg"),
        content: "CMU MSCF毕业，美本数学和统计学专业，丰富的美国量化金融机构的实习和工作经验。丰富的指导世毕盟美本学员的工作经验。",
        evaluate: ["mentor人很不错，专业度可以的，文书修改的意见也提得很中肯，群里的信息回复比较及时，基本约到比较近期的meeting时间，是个很好合作的mentor~", "mentor修改比较细致，建议后的文书从逻辑和细节上都有显著提升，回复特别及时，meeting的时候高效无废话，非常适合带美本金工的同学。", "mentor工作很认真，耐心解答学生的问题并给出专业的指导建议~"]
    }, {
        name: "Rosie",
        title: "CMU MSCF",
        image: require("@/assets/img/team/mfe_18.jpg"),
        content: "CMU MSCF毕业，金融陆本，目前为美国top投行VP；丰富的对冲基金和top投行的实习和工作经验。丰富的指导世毕盟美本学员的工作经验。",
        evaluate: ["mentor认真负责，群里学生和家长的疑问都是有问必答，即便是存在昼夜时差，回消息没有超过12h，每次meeting时，能感觉到mentor都是有充足准备的，很上心，修改意见也很到位。", "mentor工作很认真，meeting时跟学生的沟通也比较顺畅，对金工方向很了解，群里信息回复也比较及时，是个很好合作的mentor！", "meeting的这两次mentor给到学生的建议比较specific，效率也OK！"]
    }, {
        name: "Autumn",
        title: "CMU MSCF",
        image: require("@/assets/img/team/mfe_19.jpg"),
        content: "CMU MSCF, 数学专业陆本，美国头部对冲基金实习和全职工作经历，曾同时收获NYU MSMF, Cornell ORIE (FE Track),  Chicago Statistics等offers。",
        evaluate: ["mentor工作比较认真，能积极地给学生分享自己的申请经历及经验并仔细解答学生提出的申请及专业相关的问题。", "mentor指导认真负责，专业经验及信息分享十分有效且非常高效，点赞！"]
    }, {
        name: "Emilia",
        title: "Baruch MFE",
        image: require("@/assets/img/team/mfe_20.jpg"),
        content: "Baruch MFE, 数学专业陆本，美国头部对冲基金，top投资银行的实习和全职工作经历。丰富的指导世毕盟美本学员的工作经验。",
        evaluate: ["mentor工作认真负责，效率高，文书修改反馈及时，学生很满意mentor服务。", "mentor人很nice，对金工方向比较了解，群里信息回复的也比较及时，总体指导还是比较专业的~", "mentor改文书积极及时，之前给学员改过文书一稿和简历，改的很细心。"]
    }, {
        name: "Gabriel",
        title: "Baruch MFE",
        image: require("@/assets/img/team/mfe_21.jpeg"),
        content: "Baruch MFE, 美国头部对冲基金，top投资银行的实习和全职工作经历。丰富的指导世毕盟美本学员的工作经验。曾同时收获Columbia MFE, Cambridge FE等offers。",
        evaluate: ["mentor指导很给力很细致，学生对模拟面试反馈也很好。"]
    }, {
        name: "Scarlett",
        title: "UC Berkeley Haas MFE",
        image: require("@/assets/img/team/mfe_22.jpg"),
        content: "UC Berkeley Haas MFE, 丰富的美国对冲基金和top投行的实习和工作经历。丰富的指导世毕盟学员的工作经验。",
        evaluate: ["这位mentor指导效率可以的，目前指导还是不错的，回复以及meeting都挺及时~", "mentor指导的内容涉及简历及PS的修改，提供的文书修改建议都比较中肯，效率也挺高的。", "mentor学姐目前联系都很OK，开会效率非常高。"]
    }, {
        name: "Maya",
        title: "Columbia MFE",
        image: require("@/assets/img/team/mfe_23.jpg"),
        content: "Columbia MFE, 数学专业美本，国际top投资银行实习和全职工作经历；曾同时收获CMU MSCF，Stanford ICME等offers。",
        evaluate: ["mentor工作很认真，群里信息回复都比较及时，也能约到当时比较近期的meeting时间。文书指导方面也很专业，学生在她的指导下收获了很不错的一些录取，她也是个非常好合作的mentor！", "mentor整体指导可以 ，简历、文书能提出建设性意见，回复学生消息及时。", "mentor很给力，响应也及时～修改完的效果学生也很满意。"]
    }, {
        name: "Gracie",
        title: "Oxford MSc in MCF",
        image: require("@/assets/img/team/mfe_24.jpg"),
        content: "Oxford MSc in MCF，英国头部对冲基金，top投资银行的实习和全职工作经历。丰富的指导世毕盟美本学员的工作经验。",
        evaluate: ["该mentor专业度高，对金工量化金融方向相当了解，文书指导细心，回复及时，很推荐。", "mentor反馈文书及时，群里回复消息也比较快，整体的效率我觉得也蛮高的！", "mentor对学员认真上心，很负责任，同时在简历和文书上也能给到有建设性的建议，推荐使用。"]
    }],
    BSMentor: [{
        name: "Gracie",
        title: "哈佛大学商学院Technology & Operations Management博士",
        image: require("@/assets/img/team/bs_01.jpg"),
        content: "哈佛大学商学院Technology & Operations Management博士，曾同时收获 Wharton, Kellogg, Yale, UCLA, Cornell, Cambridge, Oxford等商学院博士全奖offers。",
        evaluate: []
    }, {
        name: "Brandon",
        title: "哈佛大学商学院, HBS, 管理学博士",
        image: require("@/assets/img/team/bs_02.jpeg"),
        content: "哈佛大学商学院, HBS, 管理学博士，曾同时收获Columbia Business School等商学院全奖博士offers。丰富的指导世毕盟学员的工作经验。",
        evaluate: ["我的mentor指导非常专业，回复也蛮及时的！", "mentor工作认真负责，态度温和，去年指导的学员对他的评价都还不错，群里的问题解答也面面俱到，很nice~ ", "mentor对各个项目比较了解, 回复也很及时, 学生满意度高。"]
    }, {
        name: "Thomas",
        title: "哥伦比亚大学商学院，CBS，会计学博士",
        image: require("@/assets/img/team/bs_03.jpeg"),
        content: "哥伦比亚大学商学院，CBS，会计学博士，CBS MSAFA毕业。曾同时收获Yale SOM Silver Scholar，LSE Finance， UT-Austin MPA等offers，丰富的指导世毕盟学员的工作经验。",
        evaluate: ["该mentor专业知识没问题，会计/金融PHD和金融会计硕士类的项目都可以指导。", "mentor的工作质量不错，学生也反应说他给的comment的点非常好。", "mentor专业性强，能针对文书提出有效建议，讲解细致，能站在学生角度为学生分析未来发展。"]
    }, {
        name: "Jessica",
        title: "Wharton商学院管理学博士",
        image: require("@/assets/img/team/bs_04.jpg"),
        content: "Wharton商学院管理学博士，曾同时收获斯坦福大学管理科学与工程PhD，耶鲁大学组织行为学PhD，多伦多大学战略管理学PhD等offers。",
        evaluate: ["mentor能在选校以及文书修改中给出十分专业的建议，帮助学生找到合适的写作角度，针对学生的问题回复十分积极。", "该mentor指导的很详细，思路清晰，而且超有耐心的，学生除了申商学院还会申工学院的项目，但是她也可以指导，挺可靠的，推荐使用。", "该mentor工作认真负责，微信回复及时，指导建议很实用，沟通能力强，学员是满意的，推荐使用。"]
    }, {
        name: "Bonnie",
        title: "Yale SOM市场营销博士",
        image: require("@/assets/img/team/bs_05.jpg"),
        content: "Yale SOM市场营销博士，曾同时收获CMU, UCLA, UToronto等全奖博士offers。丰富的指导世毕盟学员的工作经验。",
        evaluate: ["我觉得mentor的专业度很高，也很会沟通，同时很热心。", "mentor讲解很全面，讲解学生如何背景提升，转专业申请博士的各个博士经验分享，解答学生问题等，学生目前比较满意。", "mentor人很nice，对商科博士的申请比较了解，能针对学生的背景给出比较中肯的申请建议以及文书修改建议，群里信息回复也比较及时，是个很好合作的mentor！"]
    }, {
        name: "William",
        title: "UToronto Rotman商学院金融学博士",
        image: require("@/assets/img/team/bs_06.jpeg"),
        content: "UToronto Rotman商学院金融学博士，丰富的指导金融博士/金融硕士/金融工程硕士的工作经验。",
        evaluate: ["我的mentor高效、回复快速、给我提供了准确且有用的信息量。", "mentor回复及时，对文书修改提出的意见都很到位；沟通能力也比较强。", "mentor工作很赞，一步步引领正海成功取得套磁教授信任，最终获得PhD录取。"]
    }, {
        name: "Anthony",
        title: "普林斯顿大学运筹与金融工程博士",
        image: require("@/assets/img/team/bs_07.jpeg"),
        content: "普林斯顿大学运筹与金融工程博士，曾同时收获Columbia, Gatech, UIUC等全奖offers。丰富的指导世毕盟学员的工作经验。",
        evaluate: ["mentor很负责，回复快，文书修改也有很多建设性意见，整体挺好的，学生满意。", "mentor回复很及时，回复学员问题很详细认真。", "我的mentor人挺好的，给力！！"]
    }, {
        name: "Sophia",
        title: "剑桥大学Judge商学院管理学博士",
        image: require("@/assets/img/team/bs_08.jpg"),
        content: "剑桥大学Judge商学院管理学博士，英本英硕英博，丰富的指导世毕盟学员的工作经验。",
        evaluate: ["mentor人很好，跟学生的专业匹配度很高，能给到学生很多专业相关的建议和指导，学生今年提前申请，文书方面的指导也非常不错，是个很好合作的mentor~", "这个mentor超级好，学术水平很高对学生也很有耐心，学生也很喜欢这个mentor！", "mentor专业度非常高，和学生也能非常接地气地沟通。除了有一次因为沟通失误没能约成meeting（不是mentor的责任），合作非常愉快！"]
    }, {
        name: "Clara",
        title: "加州伯克利分校Haas商学院市场营销博士",
        image: require("@/assets/img/team/bs_09.jpg"),
        content: "加州大学伯克利分校Haas商学院市场营销博士；曾同时收获INSEAD, UMich, Caltech等全奖offers。",
        evaluate: ["mentor很认真负责，能输出。"]
    }, {
        name: "Sienna",
        title: "斯坦福大学经济学博士",
        image: require("@/assets/img/team/bs_10.jpeg"),
        content: "斯坦福大学经济学博士，曾同时收获Princeton, Yale, Kellogg, Booth等全奖offers。",
        evaluate: []
    }, {
        name: "Christian",
        title: "宾夕法尼亚大学经济学博士",
        image: require("@/assets/img/team/bs_11.jpeg"),
        content: "宾夕法尼亚大学经济学博士，曾同时收获Columbia, NYU等经济学博士offers。",
        evaluate: []
    }, {
        name: "Matthew",
        title: "剑桥大学经济学博士",
        image: require("@/assets/img/team/bs_12.jpeg"),
        content: "剑桥大学经济学博士，丰富的指导世毕盟学员的工作经验。",
        evaluate: ["mentor对学校项目了解很多，对文书的意见也提得很实际，对学生的帮助很大，并且耐心、有条理。", "该mentor专业度高，能针对文书提出有效建议，且服务态度好，耐心。", "是个很不错的mentor，meeting期间给学生详细讲了RP的写作思路和具体方向，后面RP的修改意见也提了很多，能看出工作是很用心的。"]
    }, {
        name: "Gabriel",
        title: "哥伦比亚大学经济学博士",
        image: require("@/assets/img/team/bs_13.jpg"),
        content: "哥伦比亚大学经济学博士，丰富的指导世毕盟学员的工作经验。",
        evaluate: ["位mentor指导学生非常有针对性、专业度高，给学生分析了目前背景申请博士的难度，以及基于学生目前选择方向杂乱的问题一一分析，也给予学生主申方向的建议。", "mentor指导学生非常专业，也非常及时！虽然学生拖拉，但每次都能及时抽时间指导学生！", "mentor给出的建议对学生比较适用，还讲解了学生感兴趣领域的研究情况，和学生的meeting进行的比较愉快，文书的创作学生也比较认可，总体来说学生满意度比较高。"]
    }, {
        name: "Emily",
        title: "Yale SOM Master's in Asset Management",
        image: require("@/assets/img/team/bs_14.jpeg"),
        content: "Yale SOM Master's in Asset Management毕业，国际top投行实习和工作经历，曾同时收获LSE MSc Risk and Finance, Imperial College MSc Finance等offers。",
        evaluate: ["mentor服务非常好，她回复很及时。", "mentor回复及时，给的文书建议也合理。", "学生项目和文书比较多，mentor反馈很快的，学生很满意！"]
    }, {
        name: "Nancy",
        title: "Yale SOM Master's in Asset Management",
        image: require("@/assets/img/team/bs_15.jpeg"),
        content: "Yale SOM Master's in Asset Management毕业，数学和经济学美本，曾同时收获Columbia MSBA, UC Berkeley IEOR等offers。",
        evaluate: []
    }, {
        name: "Grace",
        title: "Yale SOM Silver Scholars",
        image: require("@/assets/img/team/bs_16.jpeg"),
        content: "Yale SOM Silver Scholars，曾同时收获Yale-HKUST 以及Yale-HEC M2M offer, Insead MiM等offers。",
        evaluate: []
    }, {
        name: "Benjamin",
        title: "Yale SOM Master in Global Business & Society Candidate",
        image: require("@/assets/img/team/bs_17.jpg"),
        content: "Yale SOM Master in Global Business & Society Candidate, 曾同时收获Duke Fuqua MMS，及NUS MSc Finance等offers。",
        evaluate: ["该mentor专业度很高，而且工作很积极，反馈速度快，学生满意度挺高的。", "mentor对申请的主要内容介绍的都很详细，特别是对学生感兴趣的m2m项目做了很细致的介绍。", "mentor针对学生的背景根据自己的经验提了很多建议，也很鼓励学生多探索自己感兴趣的领域和方向。"]
    }, {
        name: "Evelyn",
        title: "Yale SOM Master in Global Business & Society Candidate",
        image: require("@/assets/img/team/bs_18.jpeg"),
        content: "Yale SOM Master in Global Business & Society Candidate, 曾同时收获LBS MiM, Insead MiM, HEC GE等offers，丰富的指导世毕盟学员的工作经验。",
        evaluate: ["mentor太给力了，meeting超级详细，行业知识充足，非常有耐心～", "mentor指导认真负责，能够对学生现状提出具体指导意见，针对学生的问题能给出有效的指导建议，meeting准时。", "mentor能力没问题，改文书给的建议比较有针对性，但学生自身问题较大。"]
    }, {
        name: "Athena",
        title: "Columbia Business School MSAFA",
        image: require("@/assets/img/team/bs_19.jpeg"),
        content: "Columbia Business School MSAFA，曾同时收获Columbia MPA in International Finance and Economic Policy, LSE MSc Finance等offers。",
        evaluate: ["mentor每次meeting对学生问题回答都十分详细，学生没想到的问题也能根据自己的经验补充回答，并且在群里回复消息也很及时。", "mentor很负责在群里回复也很及时，而且根据自己的经验都提供了很详细的指导。", "mentor在群里回复消息很及时，而且带学生很细致负责，从选课到实习到申请文书都能给出特别详细的指导，而且会根据自己过去在本科学校的经历给出对社团、课外活动的建议。"]
    }, {
        name: "Aurora",
        title: "Oxford Said商学院MSc Financial Economics",
        image: require("@/assets/img/team/bs_20.jpeg"),
        content: "Oxford Said商学院MSc Financial Economics毕业，国际top投行实习和全职工作经验。",
        evaluate: ["这个mentor是我自己学生，比较熟悉，她非常奈斯，很好沟通，有要求都可以跟她讲，会积极配合指导学生，很靠谱，回复率高，效率高，精力也充沛。", "mentor反馈非常快，且很关心学生，文书讲解思路比较清楚。"]
    }, {
        name: "Dylan",
        title: "Cambridge MPhil in Finance and Economics",
        image: require("@/assets/img/team/bs_21.jpg"),
        content: "Cambridge MPhil in Finance and Economics毕业，文科转商科申请硕士，丰富的top投行实习和工作经历，丰富的指导世毕盟学员申请的工作经历。",
        evaluate: ["mentor回复也很积极，擅长纯金融方向的指导，负责任&靠谱。", "该mentor对金融方向了解颇深，回复及时，如果忙的话也会及时沟通不会找不到人那种，而且负责细心，学生挺满意的。", "回复很快，有特殊情况，短时间内不能联系到也会提前说，学生满意。"]
    }, {
        name: "Maddison",
        title: "LBS Masters in Financial Analysis",
        image: require("@/assets/img/team/bs_22.jpeg"),
        content: "LBS Masters in Financial Analysis毕业，丰富的国际/国内投行实习和工作经验，丰富的指导世毕盟学员申请的工作经历。",
        evaluate: ["mentor人非常nice, 对LBS比较了解，相关文书指导也比较有针对性，群里信息回复很及时，也能约到比较近期的meeting, 是个非常好合作的mentor!", "mentor效率很高，回复及时，指导非常细致，属于言之有物的mentor。很推荐她", "对LBS的MFA比较了解，也是学生的dream school，给学生提了比较有针对性的申请准备建议，期待后续的合作中给出更具体的评价。"]
    }, {
        name: "Maya",
        title: "LBS Master in Management",
        image: require("@/assets/img/team/bs_23.jpg"),
        content: "LBS Master in Management毕业，文科转商科，丰富的国际/国内金融机构的实习经历。",
        evaluate: []
    }, {
        name: "Lottie",
        title: "LBS Master in Management",
        image: require("@/assets/img/team/team_img.png"),
        content: "LBS Master in Management毕业，香港地区大学本科，丰富的指导世毕盟学员申请的工作经历。",
        evaluate: []
    }],
    MathMentor: [{
        name: "",
        title: "",
        image: require("@/assets/img/team/team_img.png"),
        content: "",
        evaluate: []
    }],
    PhysMentor: [{
        name: "",
        title: "",
        image: require("@/assets/img/team/team_img.png"),
        content: "",
        evaluate: []
    }],
    ChemMentor: [{
        name: "",
        title: "",
        image: require("@/assets/img/team/team_img.png"),
        content: "",
        evaluate: []
    }],
    SSCIMentor: [{
        name: "",
        title: "",
        image: require("@/assets/img/team/team_img.png"),
        content: "",
        evaluate: []
    }],

}